import axios from "axios";

export const loginAPI = (data) => {
    return axios.post('/auth/login', data);
};

export const logoutAPI = () => {
    return axios.post('/auth/logout');
};

export const joinAPI = (data) => {
    return axios.post('/auth/join', data);
};

export const sendVerifyCodeAPI = (data) => {
    return axios.post('/auth/send-code', data);
};

export const checkVerifyCodeAPI = (data) => {
    return axios.post('/auth/confirm-code', data);
};

export const forgotPasswordAPI = (data) => {
    return axios.post('/auth/forgot-pw', data);
};

export const changePasswordAPI = (data) => {
    return axios.patch('/customer/chg-pw', data)
};

export const getRefreshTokenAPI = (data) => {
    return axios.post('/auth/re-issue', data);
};

export const checkTokenAPI = () => {
    return axios.get('/auth/token-check');
};

export const validateOtpAPI = (data) => {
    return axios.post('/auth/validate-otp', data);
}